import AppContextProviderRegistry, {
  AppContext,
  AppContextProvider,
} from '../../app/app.context.provider';
import { createDataProvider } from '../../dataprovider/dataProvider';
import { getConfig } from '../../config/app.config';
import { descopeAuthProvider } from './descope.auth.provider';
import { descopeHttpClient, getTokenProvider } from './descope.http.client';
import DescopeSdk from '@descope/web-js-sdk';


export const DESCOPE_CONTEXT_KEY = 'descope';

export class DescopeAppContextProvider implements AppContextProvider {
  constructor() {
    AppContextProviderRegistry.registerProvider(
      DESCOPE_CONTEXT_KEY,
      this
    );
  }

  public async getAppContext(): Promise<AppContext> {
    const projectId = getConfig('VITE_DESCOPE_PROJECT_ID') || 'P2rwiCEtswYYDgBRUQBZZtpYwUlE';

   

    const descope = DescopeSdk({
      projectId,
      persistTokens: true,
      sessionTokenViaCookie: false,
      autoRefresh: true,
      storeLastAuthenticatedUser: true,
      keepLastAuthenticatedUserAfterLogout: false,
    });


    const authProvider = descopeAuthProvider(descope);
    const httpClient = descopeHttpClient(descope);
    const tokenProvider = getTokenProvider(descope);
    const dataProvider = createDataProvider(httpClient);

    return {
      authProvider,
      dataProvider,
      tokenProvider,
      httpClient,
    };
  }
}